'use strict';

let featureFlags = require('../../../utilities/featureFlags'),
  personalData = null,
  isUserLoggedIn = false;

const _TRANSLATIONS_MEMBERSHIP_DOMAIN = 'membership',
  _TRANSLATIONS_MYACCOUNT_DOMAIN = 'myAccount',
  _TRANSLATIONS_DESIGNCENTER_DOMAIN = 'designCenter',
  _TRANSLATIONS_ADDRESSBOOK_KEY = 'addressBook',
  _TRANSLATIONS_ORDERHISTORY_KEY = 'orderHistory',
  _TRANSLATIONS_PROFILE_KEY = 'profileSettings',
  _TRANSLATIONS_MYPROJECTS_KEY = 'myProjects',
  _TRANSLATIONS_CHANGEPASSWORD_KEY = 'changeyourPassword',
  _ORDERHISTORY_LINK_NAME = 'orderhistory',
  _ADDRESSBOOK_LINK_NAME = 'addressbook',
  _PROFILE_LINK_NAME = 'profilesettings',
  _MYPROJECTS_LINK_NAME = 'myprojects',
  _CHANGEPASSWORD_LINK_NAME = 'changepassword';


import $ from 'jquery';
import Backbone from 'backbone';
import config from '../../../js/config';
import mediator from '../../../js/mediator';
import userService from '../../../services/CartUserService';
import utilities from '../../../js/utilities';
import Analytics from '../../Analytics/Analytics';
import {pluraliseAndTranslate} from '../../../utilities/globalisation';
import cookies from 'js-cookie';
import * as Features from '../../../utilities/featureFlags';
import loggedInMyAccountMenuTemplate from '../templates/_loggedInMyAccountMenu.hbs';

export class AccountLinksView extends Backbone.View {
  get events() {
    return {
      'click .js-logoutButton': 'logout',
      'click a[data-is-trackable]': 'onMenuClick'
    }
  }

  initialize(options) {
    this.$logoutButton = this.$el.find('.js-logoutButton');
    this.$accountDdMenuContainer = this.$el.find('.header-loggedIn');
    this.$loginButtonContainer = this.$el.find('.header-login');
    isUserLoggedIn = options.model.isUserLoggedIn;
    personalData = options.model.personalizedData;
    mediator.on(config.events.logout.crossDomainRequestCompletion, this.completeLogoutProcess, this);
    this.toggleAuthStateElements();
    this.useCachedData();
  }

  completeLogoutProcess() {
    utilities.sessionStorageRemove(config.sessionVariables.header.personalInfo);
    location.reload();
  }

  getPerksAccountLinkToHide() {
    let arrowPerksLinkToHide = config.myAccountSettings.arrowPerks;
    //If UserLoggedIn set to true, use user data from session
    const currentUser = utilities.sessionStorageLoad(config.sessionVariables.header.b2busers);
    if (currentUser && currentUser.loyalty && currentUser.loyalty.optInFlag) {
      arrowPerksLinkToHide = config.myAccountSettings.joinArrowPerks;
    }
    return arrowPerksLinkToHide;
  }

  setAccountMenuLinks() {
    if (isUserLoggedIn) {
      this.allAccountMenuLinksList = window.boostrappedAccountMenuViewModel.data || [];

      this.$menu = $('.header-loggedIn-wrapper');
      this.$menu.html(loggedInMyAccountMenuTemplate({
        accountLinks: this.allAccountMenuLinksList
      }));
    }
  }

  setPerksAccountMenuLinks() {
    let arrowPerksLinkToHide = this.getPerksAccountLinkToHide();
    let linkToHide = this.$el.find('.al-' + arrowPerksLinkToHide);
    if (linkToHide) {
      linkToHide.hide();
    }
  }

  toggleAuthStateElements() {
    if (isUserLoggedIn) {
      if (Features.DisplayMyAccountLinksSeoFriendly.isEnabled()) {
        this.setAccountMenuLinks();
      }

      this.$el.removeClass('Header-utilityLinks-login').addClass('Header-utilityLinks-loggedInUser');
      this.$accountDdMenuContainer.removeClass('account-links-hidden');
      this.$loginButtonContainer.addClass('account-links-hidden');
    } else {
      this.$el.removeClass('Header-utilityLinks-loggedInUser').addClass('Header-utilityLinks-login');
      this.$accountDdMenuContainer.addClass('account-links-hidden');
      this.$loginButtonContainer.removeClass('account-links-hidden');
    }
  }

  logout() {
    this.$logoutButton.addClass(config.classes.isWhite).addClass(config.classes.loadingClass);
    this.userLogOut()
  }

  userLogOut() {
    if (cookies.get(config.cookies.csrSignedInAsCustomer)) {
      cookies.remove(config.cookies.csrSignedInAsCustomer);
    }
    userService.siteLogout().then((data) => {
      if (featureFlags.EnableHybrisIntegration.isEnabled()) {
        console.log('Got trigger ln. 110 - bio-arrow - remove cartida AccountLinksView');
        cookies.remove(config.hybris.anonymousid);
        cookies.remove(config.cookies.accessToken);
        console.log('Got trigger ln. 112 - bio-arrow - Got Deleted cartida from AccountLinksView.js');
        utilities.sessionStorageRemove('b2busers', '');
        utilities.sessionStorageRemove('cart', '');
      }
      userService.crossSiteLogout(data);
      // profile update required should be updated else redirect to login page
      if (featureFlags.EnableEUCFieldsPh2.isEnabled()) {
        const isRedirect = sessionStorage.getItem('isOnProfileUpdate');
        if (isRedirect) {
          if (window.location.href.indexOf('profileupdate') > 0) {
            window.location.href = config.urls.loginPage;
          }
          sessionStorage.removeItem('isOnProfileUpdate');
        }
      }
    });
  }

  onMenuClick(e) {
    Analytics.pushToEventFramework({
      event: config.analytics.eventTypes.Click,
      category: config.analytics.categoryTypes.MyAccount,
      action: config.analytics.actions.AccountMenuDropdown,
      label: e.currentTarget.dataset.analyticsLabel
    });
    const isRedirect = sessionStorage.getItem('isOnProfileUpdate');
    if (featureFlags.EnableEUCFieldsPh2.isEnabled() && isRedirect) {
      this.userLogOut()
    }
  }

  translateLinkLabel(itemName) {
    switch (itemName) {
      case _ORDERHISTORY_LINK_NAME:
      {
        return pluraliseAndTranslate(_TRANSLATIONS_MEMBERSHIP_DOMAIN, _TRANSLATIONS_ORDERHISTORY_KEY);
      }
      case _ADDRESSBOOK_LINK_NAME:
      {
        return pluraliseAndTranslate(_TRANSLATIONS_MYACCOUNT_DOMAIN, _TRANSLATIONS_ADDRESSBOOK_KEY);
      }
      case _MYPROJECTS_LINK_NAME:
      {
        return pluraliseAndTranslate(_TRANSLATIONS_DESIGNCENTER_DOMAIN, _TRANSLATIONS_MYPROJECTS_KEY);
      }
      case _PROFILE_LINK_NAME:
      {
        return pluraliseAndTranslate(_TRANSLATIONS_MEMBERSHIP_DOMAIN, _TRANSLATIONS_PROFILE_KEY);
      }
      case _CHANGEPASSWORD_LINK_NAME:
      {
        return pluraliseAndTranslate(_TRANSLATIONS_MEMBERSHIP_DOMAIN, _TRANSLATIONS_CHANGEPASSWORD_KEY);
      }
    }
  }

  setGreeting() {
    // if the user is authenticated and we have a value for the greeting, set it
    if (isUserLoggedIn && personalData.greeting) {
      this.$el.find('span.Header-utilityLinks-loggedInUser--name').html(personalData.greeting);
    }
  }

  useCachedData() {
    this.setGreeting();
  }

}



// WEBPACK FOOTER //
// ./assets/components/Header/js/AccountLinksView.js